import { useSelectedClient } from '@/helpers/auth'
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    current: null,
    currentId: useSelectedClient(),
    addresses: null
}

const ACTIONS = {
    GET: 'clients/get',
    GET_ADDRESSES: 'clients/getAddresses',
    GET_ALL: 'clients/getAll'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }